/* eslint-disable react-hooks/exhaustive-deps */
import ReactLoading from 'react-loading';
import Cookies from 'js-cookie';
import api from 'api';
import { useEffect, useState } from 'react';
import { Button } from 'components';
import { BsFillCheckCircleFill, BsCircle } from 'react-icons/bs';
import { orderCoveragesArray } from 'utils/array';
import { Container } from './style';
import { Content, OptionsSide, ProductItem, ProductItemButton, CoveragesArea } from './style';
import { PolicyResume } from './styles';
import { formatCurrency } from 'react-data-formatter';

export const EditCoverages = ({ proposalData, setproposalData, setCoveragesData }) => {
  const [allCoverages, setAllCoverages] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState(proposalData?.coverages || []);
  const [loading, setLoading] = useState(false);
  const [loadingQuotation, setLoadingQuotation] = useState(false);
  const [quotationData, setQuotationData] = useState({ comission: 0.1 });
  const [quotationResponse, setQuotationResponse] = useState({});

  const loadData = async () => {
    setLoading(true);
    try {
      const resp = await api({
        method: 'GET',
        url: `/list-coverages-agent`,
        headers: {
          apiKey: 'a3607db1-530f-4565-93a1-7c2ff693c8db',
          apiSecret: 'f2b85508-8097-4adf-990a-6ba37b246fc1',
        },
        params: {
          vehicleBrand: proposalData?.vehicle?.id_brand,
          type: proposalData?.vehicle?.type || proposalData?.vehicle?.id_vehicle_type,
        },
      });
      setAllCoverages(resp?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleQuotation = async (receivedCoverages) => {
    const products =
      receivedCoverages?.length > 0 ? receivedCoverages?.map((i) => i.id) : quotationData?.products?.map((i) => i.id);

    if (products?.length > 0) {
      setLoadingQuotation(true);
      try {
        const response = await api({
          method: 'post',
          url: `/quotation-corporate-feature`,
          data: {
            ...quotationData,
            products,
          },
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
        });
        setQuotationResponse(response?.data);
        setLoadingQuotation(false);
      } catch (e) {
        setLoadingQuotation(false);
      }
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const groups = allCoverages?.map((i) => i.group);
  const uniqueGroups = groups?.filter((a, b) => groups?.findIndex((item) => item?.id === a?.id) === b);

  const toogleProduct = (product, unique) => {
    const list = selectedProducts;
    let finalList = list;

    const isInList = list.findIndex((i) => i.id === product.id) > -1;

    if (isInList) {
      const nList = list.filter((i) => i.id !== product.id);
      finalList = nList;
    } else {
      const nList = unique ? list.filter((i) => i.id_group !== product.id_group) : list;
      nList.push(product);
      finalList = nList;
    }

    setproposalData({ ...proposalData, products: finalList });
    setSelectedProducts(finalList);
    handleQuotation(finalList);
  };

  const toogleProductGroup = (products) => {
    const list = selectedProducts;
    let finalList = list;

    for (const product of products) {
      const isInList = list.findIndex((i) => i.id === product.id) > -1;

      if (isInList) {
        const nList = finalList.filter((i) => i.id !== product.id);
        finalList = nList;
      } else {
        const nList = list;
        nList.push(product);
        finalList = nList;
      }
    }

    setproposalData({ ...proposalData, products: finalList });
    setSelectedProducts(finalList);
    handleQuotation(finalList);
  };

  const CoverageItem = ({ group, coverage, info }) => {
    const groupVariants = allCoverages?.filter((i) => i?.id_group === group?.id);
    const isGrouped = groupVariants.every((i) => !i?.variation_name);
    const selected = selectedProducts.filter((item) => groupVariants.map((i) => i.id).indexOf(item.id) !== -1).length > 0;
    const hasVariations = groupVariants.every((i) => i?.variation_name);

    return (
      <ProductItem
        hasVariations={hasVariations}
        selected={selected}
        disabled={loadingQuotation}
        onClick={() =>
          !loadingQuotation && isGrouped && toogleProductGroup(allCoverages?.filter((i) => i?.id_group === group?.id))
        }
      >
        {!selected && <BsCircle size={24} style={{ marginRight: 10 }} />}
        {selected && <BsFillCheckCircleFill size={24} style={{ marginRight: 10 }} />}
        <div>
          {coverage?.group?.name} {info && <small style={{ fontWeight: 100, fontSize: 10 }}>{info}</small>}
          {hasVariations && (
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
              {orderCoveragesArray(groupVariants, 'variation_name')?.map((variant) => (
                <ProductItemButton
                  disabled={loadingQuotation}
                  onClick={() => toogleProduct(variant, true)}
                  isChecked={selectedProducts?.findIndex((listItem) => listItem.id === variant?.id) > -1}
                >
                  {variant?.variation_name}
                </ProductItemButton>
              ))}
            </div>
          )}
        </div>
      </ProductItem>
    );
  };

  return (
    <Container>
      <Content>
        <PolicyResume style={{ marginBottom: 0 }}>
          <p>Valor atual: {formatCurrency(proposalData?.value)}</p>
        </PolicyResume>

        {loading && <ReactLoading color="rgb(0 176 90)" height={24} width={24} type="spin" />}
        {!loading && (
          <OptionsSide style={{ marginTop: 0 }}>
            <h3 style={{ marginTop: 35 }}>Coberturas básicas</h3>
            <CoveragesArea>
              {uniqueGroups
                ?.filter((i) => i?.category === 'basic')
                ?.map((group) => (
                  <div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {allCoverages
                        ?.filter((i) => i?.id_group === group?.id)
                        .filter(
                          (obj, index, self) =>
                            self.findIndex((t) => {
                              return t.id_group === obj.id_group;
                            }) === index,
                        )
                        ?.map((coverage) => (
                          <CoverageItem group={group} coverage={coverage} />
                        ))}
                    </div>
                  </div>
                ))}
            </CoveragesArea>

            <h3 style={{ marginTop: 35 }}>Coberturas adicionais</h3>
            <CoveragesArea>
              {uniqueGroups
                ?.filter((i) => i?.category === 'aditional')
                ?.map((group) => (
                  <div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {allCoverages
                        ?.filter((i) => i?.id_group === group?.id)
                        .filter(
                          (obj, index, self) =>
                            self.findIndex((t) => {
                              return t.id_group === obj.id_group;
                            }) === index,
                        )
                        ?.map((coverage) => (
                          <CoverageItem info={group.id === 8 && '(Padrão 10%)'} group={group} coverage={coverage} />
                        ))}
                    </div>
                  </div>
                ))}
            </CoveragesArea>
            <div>
              <h3>Valor total: {formatCurrency(quotationData?.value || proposalData?.value || 0)}</h3>
            </div>
            <Button
              // loading={loadingUpdateUser}
              height="35px"
              style={{ marginTop: 30, marginBottom: 0 }}
              // onClick={handleUpdateUser}
              // disabled={
              //   loadingUpdateUser ||
              //   !userData?.name ||
              //   !userData?.cpf ||
              //   !userData?.email ||
              //   !userData?.phone ||
              //   !userData?.birthdate
              // }
            >
              Salvar alterações
            </Button>
          </OptionsSide>
        )}
      </Content>
    </Container>
  );
};

export default EditCoverages;
